/*
 *   File : service.js
 *   Author URI : https://evoqins.com
 *   Description : Global function for API Calls
 *   Integrations : axios
 *   Version : v1.1
*/

import axios from "axios";
import Store from "../Store/store";
import Cookies from "js-cookie";

export default async function APIService(url, data, is_post = true) {

    let access_token = Cookies.get("indvestment_access_token");
    const API_URL = process.env.REACT_APP_API_URL + url;
    const AUTH_TOKEN = access_token ? access_token : null;

    const CONFIG_OPT = {
        headers: {
            method: is_post ? "post" : "get",
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${AUTH_TOKEN}`,
        },
    };

    // POST API CALL
    if (is_post === true) {
        return await axios.post(API_URL, data, CONFIG_OPT)
            .then(function (response) {
                return response.data;
            })
            .catch((error) => {
                console.log(error)
                if (error.response.data.status_code === 401) {
                    // If user becomes unauthorized take the user to login page
                    _logout();
                }
                return error.response.data;
            });

    } else {
        // GET API CALL
        return await axios.get(API_URL, CONFIG_OPT)
            .then(function (response) {
                return response.data;
            })
            .catch((error) => {
                console.log(error)
                if (error.response.data.status_code === 401) {
                    // If user becomes unauthorized take the user to login page
                    _logout();
                }


                return error.response.data;
            });
    }

};

// Logout user
const _logout = () => {
    let options = { domain: process.env.REACT_APP_DOMAIN, path: '/' };
    Cookies.remove("indvestment_access_token", options);
    Cookies.remove("indvestment_user_id", options);
    Store.dispatch({ type: "CLEAR_STORE" });
    localStorage.removeItem("indvestment_refresh_token");
    localStorage.removeItem("indvestment_connected_broker");
    localStorage.removeItem("indvestment_is_lumpsum_broker");
    // window.location.href = "/login";
    return;
};



















